import _Vue from 'vue'

import Toast from './Toast.vue'
const ToastComponet = _Vue.extend(Toast)

function getContainer() {
  let div = document.querySelector('.toasts')
  if (div) return div
  div = document.createElement('div')
  div.classList.add('toasts')
  document.querySelector('#app')?.appendChild(div)
  return div
}

const createToastFn = root => {
  const toast = (text, opts) => {
    const vm = new ToastComponet({
      propsData: {
        text,
        options: opts || null,
      },
      parent: root, // NOTE: v-snakbarにparentが必須
    })
    const div = getContainer()
    const el = document.createElement('div')
    div.appendChild(el)
    vm.$mount(el)
  }
  toast.info = (text, opts) => {
    toast(text, Object.assign({ color: 'info' }, opts || {}))
  }
  toast.success = (text, opts) => {
    toast(text, Object.assign({ color: 'success' }, opts || {}))
  }
  toast.error = (text, opts) => {
    toast(text, Object.assign({ color: 'error' }, opts || {}))
  }
  return toast
}

export default {
  install(Vue) {
    let toast = null
    Object.defineProperty(Vue.prototype, '$toast', {
      get() {
        if (!toast) toast = createToastFn(this.$root)
        return toast
      },
    })
  },
}
